export const siteData = {
  phone: "+971504072475",
  whatsapp: "+971504072475",
  email: "info@mrmobfixer.com",

  phoneLink: "tel:+971504072475",
  whatsappLink: "https://wa.me/971504072475",
  emailLink: "mailto:info@mrmobfixer.com",
};
